import { getCloudinaryRawUrl, getCloudinaryUrl, TEAM_LINE } from "@swiggy-private/js-utils";

export const CLOSE_ICON = {
    color: "#F0F0F5",
    fill: "#616469",
    size: 28,
};

export const PLUS_ICON = {
    fill: "#02060C73",
    size: 12,
};

export const TEXTS = {
    CTA_TEXT: "Yay!",
};

export const MAX_SAVINGS_LOTTIE_CONTENT_ANIMATION_DELAY_IN_FRAMES = 85;

export const MAX_SAVINGS_LOTTIE_URL = getCloudinaryRawUrl(
    "portal/testing/double%20coupon%20savings%20V1.01.json_webp.json",
    {},
    { teamLine: TEAM_LINE.PORTAL },
);

export const TOP_LEFT_DESIGN_ELEMENT = getCloudinaryUrl("portal/m/Top%20left.png", {}, { teamLine: TEAM_LINE.PORTAL });
export const BOTTOM_RIGHT_DESIGN_ELEMENT = getCloudinaryUrl(
    "portal/m/Bottom%20right%20(1).png",
    {},
    { teamLine: TEAM_LINE.PORTAL },
);

export const DESIGN_ELEMENT_PROPS = {
    height: "150",
    width: "150",
    cloudinaryHeight: 200,
    cloudinaryWidth: 200,
};

export const TOP_LEFT_DESIGN_ELEMENT_PROPS = {
    ...DESIGN_ELEMENT_PROPS,
    alt: "Top left lines",
    src: TOP_LEFT_DESIGN_ELEMENT,
};

export const BOTTOM_RIGHT_DESIGN_ELEMENT_PROPS = {
    ...DESIGN_ELEMENT_PROPS,
    alt: "Bottom right lines",
    src: BOTTOM_RIGHT_DESIGN_ELEMENT,
};

export const CONTAINER_MIN_HEIGHT = {
    DEFAULT: "250px",
    DEFAULT_AND_LONG_PRIMARY_SAVINGS_INFO: "270px",
    WITH_SECONDARY_CALLOUTS: "330px",
    WITH_SECONDARY_CALLOUTS_AND_LONG_PRIMARY_SAVINGS_INFO: "350px",
};

export const LOTTIE_CONTAINER_HEIGHT = "220px";
export const LOTTIE_CONTAINER_HEIGHT_WITH_SECONDARY_CALLOUTS = "280px";
